import React from "react";
import PropTypes from "prop-types";

const propTypes = {
  label: PropTypes.string.isRequired
};

const Loading = ({ label }) => {
  return (
    <div className="row justify-content-start align-items-center">
      <div className="col-auto pr-1">
        <label>{label}</label>
      </div>
      <div className="col-auto pl-1">
        <div role="status" className="spinner-border text-primary">
          <span className="sr-only">Loading...</span>
        </div>
      </div>
    </div>
  );
};

Loading.propTypes = propTypes;

Loading.defaultProps = {
  label: "Loading"
};

export default Loading;
